import React from "react";
import Input from "../FormComponents/Input";

const EditSpacer = ({ editElementData, setEditElementData }) => {
  const handleHeightChange = (e) => {
    setEditElementData({ ...editElementData, height: e.target.value * 1 });
  };

  return (
    <div className="p_2">
      <Input type="number" label="Height" value={editElementData.height} onChange={handleHeightChange} />
    </div>
  );
};

export default EditSpacer;
